export default [
    {
          name: '系统信息',
          path: 'systeminfo',
          icon: 'ios-settings',
          children:
            [
              {
                name: '菜单管理',
                path: 'menulist',
                icon: 'ios-menu',
                template: 'base/menulist'
              },
              {
                name: '字典库1',
                path: 'base',
                icon: 'ios-folder',
                template: 'base/systemoption',
              },
              {
                name: '字典库2',
                path: 'dict',
                icon: 'ios-folder-open',
                template: 'base/dict',
                children:
                  [
                    {
                      name: '字典库数据列表',
                      path: 'dictlist',
                      icon: 'ios-list',
                      template: 'base/dictlist'
                    },
                  ]
              },
              {
                name: '登陆日志',
                path: 'userlog',
                icon: 'ios-clock',
                template: 'base/userlog'
              },
            ]
        },
]